import { inferenceHttp } from '@/lib/api/http-client';
import { ArtifactsService } from '@inference.engine/api-client/web';
import type { AddArtifactDto, ArtifactVersionDto } from '@inference.engine/api-client/web';

// `listWorkspaceArtifacts`, `workspaceArtifactsInfiniteQuery`, and
// `WORKSPACE_ARTIFACTS_PAGE_SIZE` lifted to `@/entities/artifact` so
// non-feature consumers (brief-generation, etc.) don't cross into this
// feature. Re-exported here for backward compat — Library's
// `ExistingArtifactsPicker` keeps importing from `@/features/artifacts/api`.
export async function getLatestArtifact(chatId: string, key: string, version: number | 'latest') {
  const response = await ArtifactsService.getArtifactVersion({
    client: inferenceHttp,
    path: { contextId: chatId, key, version },
  });
  return response.data;
}

export async function createNewArtifact(payload: AddArtifactDto): Promise<ArtifactVersionDto> {
  const response = await ArtifactsService.createNewVersion({
    client: inferenceHttp,
    path: { contextId: payload.contextId },
    body: payload,
  });

  if (!response.data) {
    throw new Error('Failed to create artifact version');
  }

  return response.data;
}
